import { t1 } from '../../../../granulometry/sections/lodgmentSections/t1';
import { getSectionTheoreticalSurface } from '../../../../granulometry/sections/queries/surfaces/getSectionTheoreticalSurface';

export const getCaseSurfaceForSaleMinimum = (): number => getSectionTheoreticalSurface(t1());
